import { selectOption } from "../Model/Common";

export const teamMemberTypeOptions: selectOption[] = [
  { value: "ADMINISTRATOR", label: "Administrator" },
  { value: "CLEAING_STAFF", label: "Cleaing Team Member" },
  { value: "CLINICAL_ASSISTANT", label: "Clinical Assistant" },
  { value: "IT_STAFF", label: "IT Team Member" },
  { value: "MEDICAL_OFFICER", label: "Medical Officer" },
  { value: "NURSING_STAFF", label: "Nursing TeamMember" },
  { value: "RECEPTIONIST", label: "Receptionist" },
  { value: "DOCTOR", label: "Doctor" },
  { value: "OTHER", label: "Other" },
];

export const DoctorteamMemberTypeOptions: selectOption[] = [
  { value: "ADMINISTRATOR", label: "Administrator" },
  { value: "CLEAING_STAFF", label: "Cleaing Team Member" },
  { value: "CLINICAL_ASSISTANT", label: "Clinical Assistant" },
  { value: "IT_STAFF", label: "IT Team Member" },
  { value: "MEDICAL_OFFICER", label: "Medical Officer" },
  { value: "NURSING_STAFF", label: "Nursing Team Member" },
  { value: "RECEPTIONIST", label: "Receptionist" },
  { value: "OTHER", label: "Other" },
];

export const prefixOptions: selectOption[] = [
  { value: "DR", label: "Dr." },
  { value: "MR", label: "Mr." },
  { value: "MS", label: "Ms." },
  { value: "MRS", label: "Mrs." },
  { value: "PROF", label: "Prof." },
];

export const genderOptions: selectOption[] = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "OTHER", label: "Other" },
];

export const maritalStatusOptions: selectOption[] = [
  { value: "SINGLE", label: "Single" },
  { value: "MARRIED", label: "Married" },
  { value: "DIVORCED", label: "Divorced" },
  { value: "WIDOWED", label: "Widowed" },
  { value: "REMARRIED", label: "Remarried" },
];

export const DoctorTypeOptions: selectOption[] = [
  { value: "CONSULTING_DOCTOR", label: "Consulting Doctor" },
  // { value: "REFERRAL_DOCTOR", label: "Referral Doctor" },
  // { value: "DOCTOR_TO_BE_REFERRED", label: "Doctor To Be Referred" },
  { value: "VISITING_DOCTOR", label: "Visiting Doctor" },
];
export const DoctorTypeOptionsForTeamMember: selectOption[] = [
  //{ value: "CONSULTING_DOCTOR", label: "Consulting Doctor" },
  // { value: "REFERRAL_DOCTOR", label: "Referral Doctor" },
  // { value: "DOCTOR_TO_BE_REFERRED", label: "Doctor To Be Referred" },
  { value: "VISITING_DOCTOR", label: "Visiting Doctor" },
];
export const DoctorTypeOptionsReferral: selectOption[] = [
  { value: "REFERRAL_DOCTOR", label: "Referral Doctor" },
  { value: "DOCTOR_TO_BE_REFERRED", label: "Doctor To Be Referred" },
  { value: "VISITING_DOCTOR", label: "Visiting Doctor" },
];

export const durationOptions: selectOption[] = [
  { value: "5_MINUTES", label: "5 Minutes" },
  { value: "10_MINUTES", label: "10 Minutes" },
  { value: "15_MINUTES", label: "15 Minutes" },
  { value: "30_MINUTES", label: "30 Minutes" },
  { value: "45_MINUTES", label: "45 Minutes" },
  { value: "1_HOURS", label: "1 Hours" },
  { value: "CUSTOM", label: "Custom" },
];

export const durationTypeOptions: selectOption[] = [
  { value: "MINUTES", label: "Minutes" },
  { value: "HOURS", label: "Hours" },
];

// RENDER EACH DAYNAME IN A LOOP
export const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const frequencyOptions = [
  { value: "FIRST", label: "First" },
  { value: "SECOND", label: "Second" },
  { value: "THIRD", label: "Third" },
  { value: "FOURTH", label: "Fourth" },
  { value: "LAST", label: "Last" },
  { value: "EVERY", label: "Every" },
];

export const roleTypeOptions = [
  { value: "ClientAdmin", label: "Admin" },
  { value: "User", label: "User" },
];
